import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { createSelector } from 'reselect';

const withPrefix = action => `ACCOUNT_${action}`;

export const activate = createAction(withPrefix('ACTIVATE'));
export const activateFail = createAction(withPrefix('ACTIVATE_FAIL'));

export const actions = {
  activate,
  activateFail,
};

const initialState = {
  loading: false,
  error: null,
};

const reducer = handleActions({
  [activate]: state => produce(state, (draft) => {
    draft.loading = true;
    draft.error = null;
  }),
  [activateFail]: (state, action) => produce(state, (draft) => {
    draft.loading = false;
    draft.error = action.payload;
  }),
}, initialState);

export default reducer;

const baseSelector = state => state.account.activation;

export const errorSelector = createSelector(baseSelector, state => state.error);



// WEBPACK FOOTER //
// ./src/features/Account/AccountActivation/account-activation-reducer.js